var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.canViewLink ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.page.name,
        params: _vm.page.params
      },
      "title": _vm.page.libelle
    }
  }, [_c('div', {
    staticClass: "relative text-lg leading-5 text-white group flex items-center space-x-4 my-3 px-6 focus:outline-none transition ease-in-out duration-150 hover:bg-indigo-700",
    class: {
      'bg-indigo-700 border-r-2 border-pink-600': _vm.currentPage === _vm.page.link || _vm.page.link != '/' && _vm.currentPage.includes('cartographies/collectives') && _vm.currentPage.includes(_vm.page.link),
      'justify-start': _vm.isFullMenu,
      'justify-center': !_vm.isFullMenu
    },
    attrs: {
      "id": _vm.page.name === 'neopass_form' ? 'menu-neopass-list' : `menu-${_vm.page.name}`
    }
  }, [_c('div', {
    staticClass: "p-4 h-full",
    class: {
      'border-pink-600 border rounded-lg': _vm.currentPage === _vm.page.link || _vm.page.link != '/' && _vm.currentPage.includes('cartographies/collectives') && _vm.currentPage.includes(_vm.page.link)
    }
  }, [_c('icon', {
    staticClass: "h-5 w-5 text-gray-300 group-hover:text-gray-300 group-focus:text-gray-300 transition ease-in-out duration-150",
    attrs: {
      "name": _vm.page.icon,
      "label": _vm.page.libelle
    }
  })], 1), _vm._v(" "), _c('p', {
    class: (_vm.isFullMenu ? '' : 'hidden') + ' pt-1'
  }, [_vm._v("\n      " + _vm._s(_vm.page.libelle) + "\n    ")]), _vm._v(" "), _vm.page.link === 'competences' ? _c('beta-tag', {
    class: _vm.isFullMenu ? '' : 'absolute transform scale-75 top-0'
  }) : _vm._e()], 1)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }